import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './retail.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { Retail } from "model/scanCodeOrder/retail.model";

export interface RetailDetailsProps extends DetailsStateAndDispatchProps<Retail>,
  RouteComponentProps, StateProps, DispatchProps {
}
const RetailDetails: FC<RetailDetailsProps> = (props) => {
  return (
    <DetailsPage<Retail>
      title={'详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<Retail>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ retail }: RootState) => ({
  entity: retail.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(RetailDetails);
